import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import { AuthProvider } from "./contexts/AuthContext";
import { ThemeProvider } from "./contexts/ThemeContext";
import ProtectedRoute from "./components/ProtectedRoute";
import MainLayout from "./components/MainLayout";
import AdminPanel from "./components/AdminPanel";
import AuthCallback from "./pages/AuthCallback";
import "./index.css";

function App() {
  return (
    <AuthProvider>
      <ThemeProvider>
        <Router>
          <div className="min-h-screen bg-gradient-to-br from-orange-50 via-white to-yellow-50 dark:from-neutral-900 dark:via-neutral-800 dark:to-neutral-900 relative overflow-hidden">
            {/* Animated background elements */}
            <div className="absolute inset-0 overflow-hidden pointer-events-none">
              {/* Gradient orbs */}
              <div className="absolute -top-40 -right-40 w-80 h-80 bg-gradient-to-br from-orange-200/30 to-yellow-200/30 dark:from-orange-800/20 dark:to-yellow-800/20 rounded-full blur-3xl animate-float"></div>
              <div
                className="absolute top-1/2 -left-40 w-96 h-96 bg-gradient-to-br from-red-200/20 to-orange-200/20 dark:from-red-800/15 dark:to-orange-800/15 rounded-full blur-3xl animate-float"
                style={{ animationDelay: "2s" }}
              ></div>
              <div
                className="absolute -bottom-40 right-1/3 w-64 h-64 bg-gradient-to-br from-yellow-200/25 to-orange-200/25 dark:from-yellow-800/15 dark:to-orange-800/15 rounded-full blur-3xl animate-float"
                style={{ animationDelay: "4s" }}
              ></div>

              {/* Construction pattern overlay */}
              <div className="absolute inset-0 bg-mesh opacity-5 dark:opacity-10"></div>
            </div>

            {/* Main content */}
            <div className="relative z-10">
              <Routes>
                {/* Auth callback route */}
                <Route path="/auth/callback" element={<AuthCallback />} />

                {/* Main route with integrated auth */}
                <Route path="/" element={<MainLayout />} />

                {/* Admin route (still protected) */}
                <Route
                  path="/admin"
                  element={
                    <ProtectedRoute>
                      <AdminPanel />
                    </ProtectedRoute>
                  }
                />

                {/* Redirect all other routes to home */}
                <Route path="*" element={<Navigate to="/" replace />} />
              </Routes>
            </div>
          </div>
        </Router>
      </ThemeProvider>
    </AuthProvider>
  );
}

export default App;
